import { render } from "./TopBar.vue?vue&type=template&id=3ac90bbe&scoped=true"
import script from "./TopBar.vue?vue&type=script&lang=js"
export * from "./TopBar.vue?vue&type=script&lang=js"

import "./TopBar.vue?vue&type=style&index=0&id=3ac90bbe&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3ac90bbe"

export default script